<script>

import { Overlay } from '../../'

export default {
    name: 'TEMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Triple Exponential Moving Average - Reduces lag even more than DEMA',
                preset: {
                    name: 'TEMA $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#3f51b5'
                    }
                }
            }
        },
        use_for() { return ['TEMA'] },
        calc() {
            return {
                props: {
                    length: { def: 20, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let first = ema(close, length)
                    let second = ema(first, length)
                    let third = ema(second, length)
                    return 3 * first[0] - 3 * second[0] + third[0]
                `
            }
        }
    }
}
</script>
